import { createContext } from 'react'
import { doctors } from '../assets/assets_frontend/assets'
import pic from "../assets/assets_frontend/mypic.jpg"

export  const AppContext =createContext()
const AppContextProvider = (props) => {
  const symbol ="$";
  
    const value={doctors,symbol,pic}
    
  return (
 <AppContext.Provider value= {value}>
{props.children}
 </AppContext.Provider>
  )
}

export default AppContextProvider